import NiceModal from "@ebay/nice-modal-react";
import {CustomDialog, Text} from "@bounce/shared/ui";

type Props = {
  onConfirm: (autoTranslate: boolean) => void;
};

const AutoTranslateDialog = NiceModal.create(({onConfirm}: Props) => (
  <CustomDialog
    title="Save template"
    forceTitle
    buttonText="Auto-translate and save"
    secondaryButtonText="Keep existing and save"
    onClick={() => onConfirm(true)}
    onClickSecondary={() => onConfirm(false)}
    width="380px"
  >
    <Text size={14}>
      The English content has changed. Would you like to override the Spanish translation with an
      auto-translation?
    </Text>
  </CustomDialog>
));

export default AutoTranslateDialog;
